/* biome-ignore-all lint/style/noParameterAssign: Need to pass ref for forwardRef */
/* biome-ignore-all lint/performance/noNamespaceImport: Cleaner when working with libraries */
'use client';

import * as Accordion from '@radix-ui/react-accordion';
import React from 'react';

const Root = React.forwardRef<
  React.ComponentRef<typeof Accordion.Root>,
  React.ComponentPropsWithoutRef<typeof Accordion.Root>
>(({ children, ...rest }, ref) => (
  <Accordion.Root
    ref={ref}
    {...rest}
  >
    {children}
  </Accordion.Root>
));
Root.displayName = 'AccordionRoot';

const Header = React.forwardRef<
  React.ComponentRef<typeof Accordion.Header>,
  React.ComponentPropsWithoutRef<typeof Accordion.Header>
>(({ children, ...rest }, ref) => (
  <Accordion.Header
    ref={ref}
    {...rest}
  >
    {children}
  </Accordion.Header>
));
Header.displayName = 'AccordionHeader';

const Item = React.forwardRef<
  React.ComponentRef<typeof Accordion.Item>,
  React.ComponentPropsWithoutRef<typeof Accordion.Item>
>(({ ...rest }, ref) => (
  <Accordion.Item
    ref={ref}
    {...rest}
  />
));
Item.displayName = 'AccordionItem';

const Trigger = React.forwardRef<
  React.ComponentRef<typeof Accordion.Trigger>,
  React.ComponentPropsWithoutRef<typeof Accordion.Trigger>
>(({ children, ...rest }, ref) => (
  <Accordion.Trigger
    ref={ref}
    {...rest}
  >
    {children}
  </Accordion.Trigger>
));
Trigger.displayName = 'AccordionTrigger';

const Content = React.forwardRef<
  React.ComponentRef<typeof Accordion.Content>,
  React.ComponentPropsWithoutRef<typeof Accordion.Content>
>(({ children, ...rest }, ref) => (
  <Accordion.Content
    ref={ref}
    {...rest}
  >
    {children}
  </Accordion.Content>
));
Content.displayName = 'AccordionContent';

export { Root, Header, Item, Trigger, Content };
